import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Fetch from "i18next-fetch-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Fetch)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: import.meta.env.VITE_STATIC_URL + "/i18n/{{lng}}.json",
    },
    load: "currentOnly",
    detection: {
      order: ["htmlTag"],
    },
    returnNull: false,
    // some Loco exports carry empty strings for untranslated keys; treat those as missing so the
    // English fallback applies instead of rendering a blank label
    returnEmptyString: false,
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  })
  .then();
